export default __webpack_public_path__ + "static/media/japan.9fa0d4a3.svg";